export default "__VITE_ASSET__CrYKCtFy__"